export default {"src":"/_next/static/media/option1bot.669ebad3.svg","height":294,"width":246,"blurWidth":0,"blurHeight":0};